module.exports = __webpack_public_path__ + "static/media/slide3.8bce7aef.webp";